<template>
    <main>
        <div class="common-report qcentric-unit-turnover-view">
            <qcentris-unit-relation/>
            <qcentris-unit-allocation/>
        </div>
    </main>
</template>

<script>
    const QcentrisUnitRelation = () => import("./qcentris-unit-turnover/QcentrisUnitRelation");
    const QcentrisUnitAllocation = () => import("./qcentris-unit-turnover/QcentrisUnitAllocation");

    export default {
        name: "QcentrisUnitTurnover",
        components: {QcentrisUnitAllocation, QcentrisUnitRelation},
        computed: {
            filter: function () {
                return this.$store.state.reports.qcentrisUnitTurnoverFilter;
            }
        },
        beforeMount() {
            this.fetchData();
        },
        methods: {
            fetchData: function () {
                this.$store.dispatch("fetchQcentrisUnitTurnover", this.filter);
                this.$store.dispatch("fetchReportAggregates", this.filter);
            }
        }
    }
</script>

<style scoped>
</style>